import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/** Daily puzzles need the verified account used by the server's free quota. */
export default function TrainingAuthGate({
  firebaseUser,
  loading,
  loadingFallback = null,
  children,
}) {
  const location = useLocation();

  if (loading) return loadingFallback;
  if (!firebaseUser) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash,
          },
        }}
      />
    );
  }

  return children;
}
